"use client";

import BotbLeaderboardProvider from "./provider";
import "./botb-leaderboard.css";
import BotBLeaderBoardPageContent from "./page-content";

const BotbLeaderBoardPage = () => {
  return (
    <BotbLeaderboardProvider>
      <BotBLeaderBoardPageContent />
    </BotbLeaderboardProvider>
  );
};

export default BotbLeaderBoardPage;
